import { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import axios from "axios";
import { API } from "../App";
import { useRadio } from "./RadioContext";
import { HearItButton } from "./HearIt";

const cache = new Map();
export const resolveMoment = async (key) => {
  if (!cache.has(key)) cache.set(key, axios.get(`${API}/radio/moments/${key}`).then((r) => r.data).catch(() => null));
  return cache.get(key);
};

// "▶ Hear it · 6:13" — plays a stable moment (by key) in the dock. Re-record later → re-point the key, link keeps working.
export const MomentButton = ({ momentKey, label, showTitle = false, className = "", testId }) => {
  const r = useRadio();
  const [m, setM] = useState(null);
  useEffect(() => { resolveMoment(momentKey).then(setM); }, [momentKey]);
  if (!m) return null;
  const active = r.episode?.slug === m.slug && r.playing && Math.abs(r.time - m.t) < 600 && r.time >= m.t;
  return <HearItButton onClick={() => (active ? r.toggle() : r.load(m.episode, m.t))} time={m.t} label={label} title={showTitle ? m.title : undefined} active={active} className={className} testId={testId || `moment-${momentKey}`} />;
};

// /listen/<key> — shareable stable URL; resolves and opens the episode page cued at that moment.
export default function ListenRedirect() {
  const { key } = useParams();
  const [to, setTo] = useState(null);
  useEffect(() => { resolveMoment(key).then((m) => setTo(m ? `/news/${m.slug}?t=${m.t}` : "/news")); }, [key]);
  return to ? <Navigate to={to} replace /> : <div className="min-h-screen bg-[#0B0716]" />;
}
